import React, { useState } from 'react';
interface WaitStepEditorProps {
  duration: number;
  unit: 'hours' | 'days' | 'weeks';
  businessDaysOnly: boolean;
  onUpdate: (data: {
    duration: number;
    unit: string;
    businessDaysOnly: boolean;
  }) => void;
}
const WaitStepEditor: React.FC<WaitStepEditorProps> = ({
  duration,
  unit,
  businessDaysOnly,
  onUpdate
}) => {
  const [currentDuration, setCurrentDuration] = useState(duration);
  const [currentUnit, setCurrentUnit] = useState(unit);
  const [currentBusinessDaysOnly, setCurrentBusinessDaysOnly] = useState(businessDaysOnly);
  const handleDurationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value) || 1;
    setCurrentDuration(value);
    onUpdate({
      duration: value,
      unit: currentUnit,
      businessDaysOnly: currentBusinessDaysOnly
    });
  };
  const handleUnitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentUnit(e.target.value as 'hours' | 'days' | 'weeks');
    onUpdate({
      duration: currentDuration,
      unit: e.target.value,
      businessDaysOnly: currentBusinessDaysOnly
    });
  };
  const handleBusinessDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentBusinessDaysOnly(e.target.checked);
    onUpdate({
      duration: currentDuration,
      unit: currentUnit,
      businessDaysOnly: e.target.checked
    });
  };
  return <div className="space-y-6" data-id="element-302">
      <h3 className="text-lg font-medium" data-id="element-303">Wait Step Configuration</h3>
      <div className="space-y-4" data-id="element-304">
        <div data-id="element-305">
          <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-306">
            Wait Duration
          </label>
          <div className="flex items-center gap-3" data-id="element-307">
            <input type="number" min="1" value={currentDuration} onChange={handleDurationChange} className="w-24 px-3 py-2 border border-gray-300 rounded-md" data-id="element-308" />
            <select value={currentUnit} onChange={handleUnitChange} className="px-3 py-2 border border-gray-300 rounded-md" data-id="element-309">
              <option value="hours" data-id="element-310">Hours</option>
              <option value="days" data-id="element-311">Days</option>
              <option value="weeks" data-id="element-312">Weeks</option>
            </select>
          </div>
        </div>
        {(currentUnit === 'days' || currentUnit === 'weeks') && <div className="flex items-center" data-id="element-313">
            <input type="checkbox" id="businessDays" checked={currentBusinessDaysOnly} onChange={handleBusinessDaysChange} className="h-4 w-4 text-blue-600 border-gray-300 rounded mr-2" data-id="element-314" />
            <label htmlFor="businessDays" className="text-sm text-gray-700" data-id="element-315">
              Business days only (Monday-Friday)
            </label>
          </div>}
        <div className="p-4 bg-gray-50 rounded-md" data-id="element-316">
          <p className="text-sm" data-id="element-317">
            This step will pause the sequence for{' '}
            <span className="font-medium" data-id="element-318">
              {currentDuration} {currentUnit}
            </span>
            {currentBusinessDaysOnly && currentUnit !== 'hours' ? ' (business days only)' : ''}{' '}
            before proceeding to the next step.
          </p>
        </div>
      </div>
    </div>;
};
export default WaitStepEditor;